/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { noop } from '@amazon/vinyl-util'
import type { Player } from '@/playback/api'
import type { PlaylistEntry } from '@/playback/PlaylistController'
import { markUserSkip } from '@/playback/metrics/userSkipSignal'
import { isAudiobookEntry } from '@/playback/playbackEntryKind'

/**
 * Audiobook transport next: an audiobook is a single feed entry, so next steps
 * to the next CHAPTER via the player's section-nav surface instead of skipping
 * the feed (GH parity). Returns true when it handled the entry (audiobook) so
 * the caller skips its normal feed-skip path; false for non-audiobooks.
 */
export function stepAudiobookNext(player: Player, entry: PlaylistEntry | null): boolean {
    if (!isAudiobookEntry(entry)) return false
    markUserSkip('next')
    void Promise.resolve(player.sections.nextSection()).catch(noop)
    return true
}
